/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { PaysDto } from '../models/pays-dto';


/**
 * Fonctions de gestion des pays
 */
@Injectable({
  providedIn: 'root',
})
export class PaysService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation paysGetList
   */
  static readonly PaysGetListPath = '/api/pays/list';

  /**
   * Renvoie la liste des pays.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paysGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  paysGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<PaysDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PaysService.PaysGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PaysDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des pays.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `paysGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paysGetList(params?: {
  }): Observable<Array<PaysDto>> {

    return this.paysGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PaysDto>>) => r.body as Array<PaysDto>)
    );
  }

  /**
   * Path part for operation paysLoadList
   */
  static readonly PaysLoadListPath = '/api/pays/load-list';

  /**
   * Renvoie la liste des pays (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paysLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paysLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PaysService.PaysLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des pays (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `paysLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paysLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.paysLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation paysGet
   */
  static readonly PaysGetPath = '/api/pays/{id}';

  /**
   * Renvoie le pays spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paysGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  paysGet$Response(params: {

    /**
     * Identifiant du pays
     */
    id: number;
  }): Observable<StrictHttpResponse<PaysDto>> {

    const rb = new RequestBuilder(this.rootUrl, PaysService.PaysGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaysDto>;
      })
    );
  }

  /**
   * Renvoie le pays spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `paysGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paysGet(params: {

    /**
     * Identifiant du pays
     */
    id: number;
  }): Observable<PaysDto> {

    return this.paysGet$Response(params).pipe(
      map((r: StrictHttpResponse<PaysDto>) => r.body as PaysDto)
    );
  }

  /**
   * Path part for operation paysPut
   */
  static readonly PaysPutPath = '/api/pays/{id}';

  /**
   * Met à jour le pays spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paysPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paysPut$Response(params: {

    /**
     * Identifiant du pays à mettre à jour
     */
    id: number;

    /**
     * Pays
     */
    body: PaysDto
  }): Observable<StrictHttpResponse<PaysDto>> {

    const rb = new RequestBuilder(this.rootUrl, PaysService.PaysPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaysDto>;
      })
    );
  }

  /**
   * Met à jour le pays spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `paysPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paysPut(params: {

    /**
     * Identifiant du pays à mettre à jour
     */
    id: number;

    /**
     * Pays
     */
    body: PaysDto
  }): Observable<PaysDto> {

    return this.paysPut$Response(params).pipe(
      map((r: StrictHttpResponse<PaysDto>) => r.body as PaysDto)
    );
  }

  /**
   * Path part for operation paysDelete
   */
  static readonly PaysDeletePath = '/api/pays/{id}';

  /**
   * Supprime le pays spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paysDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  paysDelete$Response(params: {

    /**
     * Identifiant du pays à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, PaysService.PaysDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le pays spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `paysDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paysDelete(params: {

    /**
     * Identifiant du pays à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.paysDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation paysPost
   */
  static readonly PaysPostPath = '/api/pays';

  /**
   * Crée le pays spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paysPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paysPost$Response(params: {

    /**
     * Pays
     */
    body: PaysDto
  }): Observable<StrictHttpResponse<PaysDto>> {

    const rb = new RequestBuilder(this.rootUrl, PaysService.PaysPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaysDto>;
      })
    );
  }

  /**
   * Crée le pays spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `paysPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paysPost(params: {

    /**
     * Pays
     */
    body: PaysDto
  }): Observable<PaysDto> {

    return this.paysPost$Response(params).pipe(
      map((r: StrictHttpResponse<PaysDto>) => r.body as PaysDto)
    );
  }

  /**
   * Path part for operation paysDesactivate
   */
  static readonly PaysDesactivatePath = '/api/pays/{id}/desactivate';

  /**
   * Désactive le pays spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paysDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paysDesactivate$Response(params: {

    /**
     * Identifiant du pays à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: PaysDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, PaysService.PaysDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive le pays spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `paysDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  paysDesactivate(params: {

    /**
     * Identifiant du pays à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: PaysDto
  }): Observable<number> {

    return this.paysDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation paysGetByReference
   */
  static readonly PaysGetByReferencePath = '/api/pays/reference/{reference}';

  /**
   * Renvoie le pays recherché par référence.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paysGetByReference()` instead.
   *
   * This method doesn't expect any request body.
   */
  paysGetByReference$Response(params: {

    /**
     * Référence
     */
    reference: string;
  }): Observable<StrictHttpResponse<PaysDto>> {

    const rb = new RequestBuilder(this.rootUrl, PaysService.PaysGetByReferencePath, 'get');
    if (params) {
      rb.path('reference', params.reference, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaysDto>;
      })
    );
  }

  /**
   * Renvoie le pays recherché par référence.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `paysGetByReference$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paysGetByReference(params: {

    /**
     * Référence
     */
    reference: string;
  }): Observable<PaysDto> {

    return this.paysGetByReference$Response(params).pipe(
      map((r: StrictHttpResponse<PaysDto>) => r.body as PaysDto)
    );
  }

}
